import { Platform } from 'quasar'
import { Preferences } from '@capacitor/preferences';

const getCourseIdBasedOnSlug = (slug) => {
	return slug.split('-id-')[1]
}

const routes = (store) => [
	{
		path: '/tigre-juntos-somos-mais',
		name: 'tigre_juntos_somos_mais',
		component: () => import('pages/tigre_jsm/TigreJSM.vue'),
	},
	{
		path: '/youtube-iframe',
		name: 'youtube_iframe',
		component: () => import('pages/iframe/YouTubeIframe.vue'),
	},
	{
		path: '/',
		component: () => import('layouts/Open.vue'),
		children: [
			{
				path: 'institutional/about',
				name: 'login_about',
				component: () =>
					Platform.is.mobile
						? import('pages/about/LoginAboutMobile.vue')
						: import('pages/about/LoginAbout.vue'),
				meta: { title: 'about', parent: 'open' },
			},
			{
				path: 'institutional/cookies_policy',
				name: 'login_cookies_policy',
				component: () =>
					Platform.is.mobile
						? import('pages/policy/LoginCookiesPolicyMobile.vue')
						: import('pages/policy/LoginCookiesPolicy.vue'),
				meta: { title: 'cookies_policy', parent: 'open' },
			},
			{
				path: 'institutional/support',
				name: 'login_support',
				component: () =>
					Platform.is.mobile
						? import('pages/support/LoginSupportMobile.vue')
						: import('pages/support/LoginSupport.vue'),
				meta: { title: 'support', parent: 'open' },
			},
			{
				path: '',
				name: 'login',
				component: () =>
					Platform.is.mobile
						? import('pages/login/LoginMobile.vue')
						: import('pages/login/LoginDesktop.vue'),
				meta: { title: 'login', parent: 'open' },
			},
			{
				path: 'maintenance-login',
				name: 'maintenance_login',
				component: () =>
					Platform.is.mobile
						? import('pages/login/LoginMobile.vue')
						: import('pages/login/LoginDesktop.vue'),
				props: true,
			},
			{
				path: 'login-redirect-v2',
				name: 'login_redirect_v2',
				component: () =>
					Platform.is.mobile
						? import('pages/login/LoginMobile.vue')
						: import('pages/login/LoginDesktop.vue'),
				meta: { title: 'login_redirect_v2', parent: 'open' },
			},
			{
				path: 'webservice-login/:token',
				name: 'webservice-login',
				component: () =>
					Platform.is.mobile
						? import('pages/login/LoginMobile.vue')
						: import('pages/login/LoginDesktop.vue'),
				meta: { title: 'webservice-login', parent: 'open' },
			},
			{
				path: 'webservice-login/',
				name: 'webservice-login-unauthenticated',
				component: () =>
					Platform.is.mobile
						? import('pages/login/LoginMobile.vue')
						: import('pages/login/LoginDesktop.vue'),
				meta: { title: 'webservice-login-unauthenticated', parent: 'open' },
			},
			{
				path: 'institutional/privacy-policy',
				name: 'login_privacy_policy',
				component: () =>
					Platform.is.mobile
						? import('pages/privacy_policy/LoginPrivacyPolicyMobile.vue')
						: import('pages/privacy_policy/LoginPrivacyPolicy.vue'),
				meta: { title: 'privacy_policy', parent: 'open' },
			},
			{
				path: 'set-password/:username/:uidb64/:token',
				name: 'set_password',
				component: () =>
					Platform.is.mobile
						? import('pages/set_password/SetPasswordMobile.vue')
						: import('pages/set_password/SetPasswordDesktop.vue'),
				meta: { title: 'set_password', parent: 'open' },
			},
			{
				path: 'request-password/',
				name: 'request_password',
				component: () =>
					Platform.is.mobile
						? import('pages/request_password/RequestPasswordMobile.vue')
						: import('pages/request_password/RequestPasswordDesktop.vue'),
				meta: { title: 'request_password', parent: 'open' },
				props: false,
			},
			{
				path: 'first_access/',
				name: 'first_access',
				component: () => import('pages/first_access/FirstAccess.vue'),
				meta: { title: 'request_password', parent: 'open' },
				props: false,
			},
			{
				path: 'recover-password/:username/:uidb64/:token',
				name: 'recover_password',
				component: () =>
					Platform.is.mobile
						? import('pages/set_password/SetPasswordMobile.vue')
						: import('pages/set_password/SetPasswordDesktop.vue'),
				meta: { title: 'recover_password', parent: 'open' },
				props: false,
			},
			{
				path: 'register',
				name: 'register',
				component: () => import('src/pages/register/Register.vue'),
				meta: { title: 'register', parent: 'open' },
			},
			{
				path: 'register-success',
				name: 'register-success',
				component: () => import('src/pages/register/RegisterSuccess.vue'),
				meta: { title: 'register', parent: 'open' },
			},
			{
				path: 'register-seven-trade',
				name: 'register-seven-trade',
				component: () => import('src/pages/register/RegisterPopSevenTrade.vue'),
				meta: { title: 'register', parent: 'open' },
			},
			{
				path: 'register-pop-trade',
				name: 'register-pop-trade',
				component: () => import('src/pages/register/RegisterPopSevenTrade.vue'),
				meta: { title: 'register', parent: 'open' },
			},
			{
				path: 'institutional/terms-and-conditions',
				name: 'login_terms_and_conditions',
				component: () =>
					Platform.is.mobile
						? import('pages/terms_and_conditions/LoginTermsAndConditionsMobile.vue')
						: import('pages/terms_and_conditions/LoginTermsAndConditions.vue'),
				meta: { title: 'terms_and_conditions', parent: 'open' },
			},
		],
		beforeEnter: async (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			const { value: access_token_ios } = await Preferences.get({ key: 'access_token' });
			if (store.getters['common/access_token'] || access_token_ios) {
				let clients = store.getters['params/clients']
				let id_user_client_selected
				if (Platform.is.ios) {
					const { value: id_user_client_selected_ios } = await Preferences.get({ key: 'id_user_client_selected' });
					const { value: clients_ios } = await Preferences.get({ key: 'clients' });
					id_user_client_selected = id_user_client_selected_ios
					clients = clients_ios ? JSON.parse(clients_ios) : []
				} else {
					id_user_client_selected = store.getters['common/id_user_client_selected']
					clients = store.getters['params/clients']
				}

				var obj = clients.find((obj) => {
					return obj.id == id_user_client_selected
				})
			}
			if (obj) {
				if (to.name == 'webservice-login') {
					let hasAccess = false
					if (to.query.id) {
						if (to.query.module === 'library_single') {
							hasAccess = obj?.[`has_library`]
						} else if (to.query.module === 'news_single') {
							hasAccess = obj?.[`has_news`]
						} else if (to.query.module == 'webinar') {
							hasAccess = obj?.[`has_webcasts`]
						} else {
							hasAccess = obj?.[`has_${to.query.module}s`]
						}
					} else {
						if (to.query.module == 'webinars') {
							hasAccess = obj?.[`has_webcasts`]
						} else if (to.query.module == 'profile') {
							hasAccess = obj?.[`has_profile`]
						} else {
							hasAccess = obj?.[`has_${to.query.module}`]
						}
					}
					if (hasAccess) {
						next({
							name: to.query.module,
							params: { id: to.query.id },
						})
					} else {
						next({
							name: obj.home_route,
						})
					}
					next({ name: obj.home_route, query: to.query })
				} else if (to.name == 'login_redirect_v2') {
					clearUserData(store)
					next()
				} else {
					next({ name: obj.home_route, query: store.state.common.redirect_url })
				}
			} else if (store.getters['params/use_portfolio_page'] === true && to.name === 'login') {
				if (to.redirectedFrom) {
					store.dispatch('common/SET_REDIRECT_URL', [to.redirectedFrom.query])
				} else {
					store.dispatch('common/SET_REDIRECT_URL', [to.query])
				}
				next({ name: 'portfolio' })
			} else {
				if (to.name !== 'login_redirect_v2') store.dispatch('common/SET_REDIRECT_URL', [to.query])
				if (from.name != 'portfolio') clearUserData(store)
				next()
			}
		},
	},
	{
		path: '/',
		component: () => import('layouts/IntelFirstAccess.vue'),
		children: [
			{
				path: 'intel-first-access',
				name: 'intel_first_access',
				component: () => import('pages/intel_first_access/IntelFirstAccess.vue'),
				meta: { title: 'intel_first_access', parent: 'open' },
			},
			{
				path: 'intel-login-redirect',
				name: 'intel_login_redirect',
				component: () => import('pages/intel_login_redirect/IntelLoginRedirect.vue'),
				meta: { title: 'intel_login_redirect', parent: 'open' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}

			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/Portfolio.vue'),
		children: [
			{
				path: 'portfolio',
				name: 'portfolio',
				component: () => import('pages/portfolio/Portfolio.vue'),
				meta: { title: 'portfolio', parent: 'portfolio' },
			},
			{
				path: 'portfolio-course/:slug',
				name: 'portfolio_course',
				component: () =>
					Platform.is.mobile
						? import('pages/portfolio_course/PortfolioCourseMobile.vue')
						: import('pages/portfolio_course/PortfolioCourseDesktop.vue'),
				props: (route) => ({
					slug: route.params.slug,
					courseId: getCourseIdBasedOnSlug(route.params.slug),
				}),
				meta: { title: 'portfolio', parent: 'portfolio' },
			},
			{
				path: 'about-team',
				name: 'about_team',
				component: () => import('pages/about_team/AboutTeam.vue'),
				meta: { title: 'about_team', parent: 'about_team' },
			},
		],
		beforeEnter: async (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}

			if (to.name === 'about_team') {
				next()
			} else {
				const { value: access_token_ios } = await Preferences.get({ key: 'access_token' });
				if (store.getters['common/access_token'] || access_token_ios) {
					let clients = store.getters['params/clients']
					let id_user_client_selected
					if (Platform.is.ios) {
						const { value: id_user_client_selected_ios } = await Preferences.get({ key: 'id_user_client_selected' });
						const { value: clients_ios } = await Preferences.get({ key: 'clients' });
						id_user_client_selected = id_user_client_selected_ios
						clients = clients_ios ? JSON.parse(clients_ios) : []
					} else {
						id_user_client_selected = store.getters['common/id_user_client_selected']
						clients = store.getters['params/clients']
					}

					var obj = clients.find((obj) => {
						return obj.id == id_user_client_selected
					})
					if (obj) {
						next({ name: obj.home_route, query: to.query })
					} else {
						next({ name: 'courses', query: to.query })
					}
				} else {
					clearUserData(store)
					next()
				}
			}
		},
	},
	{
		path: '/',
		component: () => import('layouts/Closed.vue'),
		children: [
			{
				path: 'home',
				name: 'home',
				component: () =>
					Platform.is.mobile
						? import('pages/home/HomeMobile.vue')
						: import('pages/home/HomeDesktop.vue'),
				meta: { title: 'home', parent: 'closed' },
			},
			{
				path: 'home/surveys/:survey_id',
				name: 'home_surveys',
				component: () =>
					Platform.is.mobile
						? import('pages/home/HomeMobile.vue')
						: import('pages/home/HomeDesktop.vue'),
				meta: { title: 'home', parent: 'closed' },
			},
			{
				path: 'online-courses',
				name: 'courses',
				component: () =>
					Platform.is.mobile
						? import('pages/courses/CoursesMobile.vue')
						: import('pages/courses/CoursesDesktop.vue'),
				meta: { title: 'courses', parent: 'closed' },
			},
			{
				path: 'online-courses/:id',
				name: 'course',
				component: () =>
					Platform.is.mobile
						? import('pages/courses/CourseMobile.vue')
						: import('pages/courses/CourseDesktop.vue'),
				meta: { title: 'courses', parent: 'closed' },
			},
			{
				path: 'courses',
				redirect: 'online-courses',
			},
			{
				path: 'courses/:id',
				redirect: (to) => {
					return { path: `online-courses/${to.params.id}` }
				},
			},
			{
				path: 'trails',
				name: 'trails',
				component: () =>
					Platform.is.mobile
						? import('pages/trails/TrailsMobile.vue')
						: import('pages/trails/TrailsDesktop.vue'),
				meta: { title: 'trails', parent: 'closed' },
			},
			{
				path: 'trails/:id',
				name: 'trail',
				component: () =>
					Platform.is.mobile
						? import('pages/trails/TrailMobile.vue')
						: import('pages/trails/TrailDesktop.vue'),
				meta: { title: 'trails', parent: 'closed' },
			},
			{
				path: 'trails/:id_trail/course/:id',
				name: 'trail_course',
				component: () =>
					Platform.is.mobile
						? import('pages/courses/CourseMobile.vue')
						: import('pages/courses/CourseDesktop.vue'),
				meta: { title: 'trails', parent: 'closed' },
			},
			{
				path: 'trails/:id_trail/presential-catalogs/:id',
				name: 'presentials_catalogs',
				component: () =>
					Platform.is.mobile
						? import('pages/presential_catalogs/CatalogsMobile.vue')
						: import('pages/presential_catalogs/CatalogsDesktop.vue'),
				meta: { title: 'trails', parent: 'closed' },
			},
			{
				path: 'presential-courses',
				name: 'presentials',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/PresentialsMobile.vue')
						: import('pages/presential/PresentialsDesktop.vue'),
				meta: { title: 'presentials', parent: 'closed' },
			},
			{
				path: 'presential-courses/:id',
				name: 'presential',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/PresentialMobile.vue')
						: import('pages/presential/PresentialDesktop.vue'),
				meta: { title: 'presentials', parent: 'closed' },
			},
			{
				path: 'trails/:id_trail/presential-catalogs/:id_catalog/presential-courses/:id',
				name: 'trail_presential',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/PresentialMobile.vue')
						: import('pages/presential/PresentialDesktop.vue'),
				meta: { title: 'presentials', parent: 'closed' },
			},
			{
				path: 'presential',
				redirect: 'presential-courses',
			},
			{
				path: 'presential/:id',
				redirect: (to) => {
					return { path: `presential-courses/${to.params.id}` }
				},
			},
			{
				path: 'webinars',
				name: 'webinars',
				component: () =>
					Platform.is.mobile
						? import('pages/webinars/WebinarsMobile.vue')
						: import('pages/webinars/WebinarsDesktop.vue'),
				meta: { title: 'webinars', parent: 'closed' },
			},
			{
				path: 'webinars/:id',
				name: 'webinar',
				component: () =>
					Platform.is.mobile
						? import('pages/webinars/WebinarMobile.vue')
						: import('pages/webinars/WebinarDesktop.vue'),
				meta: { title: 'webinars', parent: 'closed' },
			},
			{
				path: 'trails/:id_trail/webinars/:id',
				name: 'trail_webinar',
				component: () =>
					Platform.is.mobile
						? import('pages/webinars/WebinarMobile.vue')
						: import('pages/webinars/WebinarDesktop.vue'),
				meta: { title: 'webinars', parent: 'closed' },
			},
			{
				path: 'webcasts',
				redirect: 'webinars',
			},
			{
				path: 'webcasts/:id',
				redirect: (to) => {
					return { path: `webinars/${to.params.id}` }
				},
			},
			{
				path: 'live-classes',
				name: 'live_classes',
				component: () =>
					Platform.is.mobile
						? import('pages/live_classes/LiveClassesMobile.vue')
						: import('pages/live_classes/LiveClassesDesktop.vue'),
				meta: { title: 'live_classes', parent: 'closed' },
			},
			{
				path: 'live-classes/:id',
				name: 'live_class',
				component: () =>
					Platform.is.mobile
						? import('pages/live_classes/LiveClassMobile.vue')
						: import('pages/live_classes/LiveClassDesktop.vue'),
				meta: { title: 'live_classes', parent: 'closed' },
			},
			{
				path: 'trails/:id_trail/live-classes/:id',
				name: 'trail_live_class',
				component: () =>
					Platform.is.mobile
						? import('pages/live_classes/LiveClassMobile.vue')
						: import('pages/live_classes/LiveClassDesktop.vue'),
				meta: { title: 'live_classes', parent: 'closed' },
			},
			{
				path: 'podcasts',
				name: 'podcasts',
				component: () =>
					Platform.is.mobile
						? import('pages/podcasts/PodcastsMobile.vue')
						: import('pages/podcasts/PodcastsDesktop.vue'),
				meta: { title: 'podcasts', parent: 'closed' },
			},
			{
				path: 'podcasts/:id',
				name: 'podcasts-show',
				component: () =>
					Platform.is.mobile
						? import('pages/podcasts/PodcastsMobile.vue')
						: import('pages/podcasts/PodcastsDesktop.vue'),
				meta: { title: 'podcasts', parent: 'closed' },
			},
			{
				path: 'podcasts/search/:name',
				name: 'podcasts-search-name',
				component: () =>
					Platform.is.mobile
						? import('pages/podcasts/PodcastsMobile.vue')
						: import('pages/podcasts/PodcastsDesktop.vue'),
				meta: { title: 'podcasts', parent: 'closed' },
			},
			{
				path: 'library',
				name: 'library',
				component: () =>
					Platform.is.mobile
						? import('pages/library/LibraryMobile.vue')
						: import('pages/library/LibraryDesktop.vue'),
				meta: { title: 'library', parent: 'closed' },
			},
			{
				path: 'library/:name',
				name: 'library-search-name',
				component: () =>
					Platform.is.mobile
						? import('pages/library/LibraryMobile.vue')
						: import('pages/library/LibraryDesktop.vue'),
				meta: { title: 'library', parent: 'closed' },
				props: true,
			},
			{
				path: 'libraries/:id',
				name: 'library_single',
				component: () =>
					Platform.is.mobile
						? import('pages/library/LibraryMobile.vue')
						: import('pages/library/LibraryDesktop.vue'),
				meta: { title: 'library', parent: 'closed' },
				props: true,
			},
			{
				path: 'news',
				name: 'news',
				component: () =>
					Platform.is.mobile
						? import('pages/news/NewsMobile.vue')
						: import('pages/news/NewsDesktop.vue'),
				meta: { title: 'news', parent: 'closed' },
			},
			{
				path: 'news/:id',
				name: 'news_single',
				component: () =>
					Platform.is.mobile
						? import('pages/news/NewsMobile.vue')
						: import('pages/news/NewsDesktop.vue'),
				meta: { title: 'news', parent: 'closed' },
			},
			// {
			// 	path: 'reward-store',
			// 	name: 'reward_store',
			// 	component: () => import('pages/reward_store/RewardStore.vue'),
			// 	meta: { title: 'reward_store', parent: 'closed' },
			// },
			{
				path: 'reward-store',
				name: 'reward_store',
				component: () => import('pages/rewards_store/RewardsStore.vue'),
				meta: { title: 'reward_store', parent: 'closed' },
			},
			{
				path: 'reward-store/details/:id/',
				name: 'reward_details',
				component: () => import('pages/reward_store/RewardDetails.vue'),
				meta: { title: 'reward_store', parent: 'closed' },
			},
			{
				path: 'points-table',
				name: 'points_table',
				component: () => import('pages/points_table/PointsTable.vue'),
				meta: { title: 'points_table', parent: 'closed' },
			},
			{
				path: 'campaigns',
				name: 'campaigns',
				component: () => import('pages/campaigns/Campaigns.vue'),
				meta: { title: 'campaigns', parent: 'closed' },
			},
			{
				path: 'profile',
				name: 'profile',
				component: () =>
					Platform.is.mobile
						? import('pages/profile/ProfileMobile.vue')
						: import('pages/profile/ProfileDesktop.vue'),
				meta: { title: 'profile', parent: 'closed' },
			},
			{
				path: 'events',
				name: 'events',
				component: () => import('pages/events/Events.vue'),
				meta: { title: 'events', parent: 'closed' },
			},
			{
				path: 'terms-and-conditions',
				name: 'terms_and_conditions',
				component: () => import('pages/terms_and_conditions/TermsAndConditions.vue'),
				meta: { title: 'terms_and_conditions', parent: 'closed' },
			},
			{
				path: 'faq',
				name: 'faq',
				component: () => import('pages/faq/Faq.vue'),
				meta: { title: 'faq', parent: 'closed' },
			},
			{
				path: 'support',
				name: 'support',
				component: () =>
					Platform.is.mobile
						? import('pages/support/SupportMobile.vue')
						: import('pages/support/Support.vue'),
				meta: { title: 'support', parent: 'closed' },
			},
			{
				path: 'privacy-policy',
				name: 'privacy_policy',
				component: () => import('pages/privacy_policy/PrivacyPolicy.vue'),
				meta: { title: 'privacy_policy', parent: 'closed' },
			},
			{
				path: 'cookies',
				name: 'cookies_policy',
				component: () => import('pages/policy/CookiesPolicy.vue'),
				meta: { title: 'cookies_policy', parent: 'closed' },
			},
			{
				path: 'about-the-program',
				name: 'about-the-program',
				component: () => import('pages/about/About.vue'),
				meta: { title: 'about_the_program', parent: 'closed' },
			},
			{
				path: 'about',
				name: 'about',
				component: () => import('pages/about/PageAbout.vue'),
				meta: { title: 'about', parent: 'closed' },
			},
			{
				path: 'contact-us',
				name: 'contact-us',
				component: () => import('pages/contact_us/ContactUs.vue'),
				meta: { title: 'contact_us', parent: 'closed' },
			},
			{
				path: 'insert-sales',
				name: 'insert_sales',
				component: () => import('pages/insert_sales/InsertSales.vue'),
				meta: { title: 'insert_sales', parent: 'closed' },
			},
			{
				path: 'upload-photos',
				name: 'upload_photos',
				component: () => import('pages/upload_photos/UploadPhotos.vue'),
				meta: { title: 'upload_photos', parent: 'closed' },
			},
			{
				path: 'about-the-team',
				name: 'about_the_team',
				component: () => import('pages/about_team/AboutTeam.vue'),
				meta: { title: 'about_the_team', parent: 'closed' },
			},
			{
				path: 'hotsite',
				name: 'hotsite',
				component: () => import('pages/hotsite/Hotsite.vue'),
				meta: { title: 'hotsite', parent: 'closed' },
			},
		],
		beforeEnter: async (to, from, next) => {

			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			const { value: access_token_ios } = await Preferences.get({ key: 'access_token' });
			if (!store.getters['common/access_token'] && !access_token_ios) {
				clearUserData(store)
				if (to.query.hasOwnProperty('token')) {
					store.dispatch('redirect/SET_TOKEN', [to.query.token])
				}
				store.dispatch('redirect/SET_REDIRECT', [to.path])
				next({ name: 'login' })
			} else {
				if (to.query.hasOwnProperty('token')) {
					clearUserData(store)
					store.dispatch('redirect/SET_TOKEN', [to.query.token])

					store.dispatch('redirect/SET_REDIRECT', [to.path])
					next({ name: 'login' })
				} else if (store.getters['redirect/redirect'] !== '') {
					let redirect = store.getters['redirect/redirect']
					store.dispatch('redirect/SET_REDIRECT', [''])
					next({ path: redirect })
				} else {
					next()
				}
			}
		},
	},
	{
		path: '/',
		component: () => import('layouts/Classes.vue'),
		children: [
			{
				path: 'courses/:id/activities/:hierarchy_order',
				name: 'course_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/courses/ActivitiesMobile.vue')
						: import('pages/courses/ActivitiesDesktop.vue'),
				meta: { title: 'courses', parent: 'classes' },
			},
			{
				path: 'trails/:id_trail/course/:id/activities/:hierarchy_order',
				name: 'trail_course_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/courses/ActivitiesMobile.vue')
						: import('pages/courses/ActivitiesDesktop.vue'),
				meta: { title: 'trails', parent: 'classes' },
			},
		],
		beforeEnter: async (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			const { value: access_token_ios } = await Preferences.get({ key: 'access_token' });
			if (!store.getters['common/access_token'] && !access_token_ios) {
				clearUserData(store)
				if (to.query.hasOwnProperty('token')) {
					store.dispatch('redirect/SET_TOKEN', [to.query.token])
				}
				store.dispatch('redirect/SET_REDIRECT', [to.path])
				next({ name: 'login' })
			} else {
				if (to.query.hasOwnProperty('token')) {
					clearUserData(store)
					store.dispatch('redirect/SET_TOKEN', [to.query.token])

					store.dispatch('redirect/SET_REDIRECT', [to.path])
					next({ name: 'login' })
				} else if (store.getters['redirect/redirect'] !== '') {
					let redirect = store.getters['redirect/redirect']
					store.dispatch('redirect/SET_REDIRECT', [''])
					next({ path: redirect })
				} else {
					next()
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/Webinars.vue'),
		children: [
			{
				path: 'webinars/:id/activities/:hierarchy_order',
				name: 'webinar_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/webinars/ActivitiesMobile.vue')
						: import('pages/webinars/ActivitiesDesktop.vue'),
				meta: { title: 'courses', parent: 'webinars' },
			},
			{
				path: 'trails/:id_trail/webinars/:id/activities/:hierarchy_order',
				name: 'trail_webinar_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/webinars/ActivitiesMobile.vue')
						: import('pages/webinars/ActivitiesDesktop.vue'),
				meta: { title: 'trails', parent: 'classes' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/LiveClass.vue'),
		children: [
			{
				path: 'live-classes/:id/activities/:hierarchy_order',
				name: 'live_class_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/live_classes/ActivitiesMobile.vue')
						: import('pages/live_classes/ActivitiesDesktop.vue'),
				meta: { title: 'live_classes', parent: 'live_class' },
			},
			{
				path: 'trails/:id_trail/live-classes/:id/activities/:hierarchy_order',
				name: 'trail_live_class_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/live_classes/ActivitiesMobile.vue')
						: import('pages/live_classes/ActivitiesDesktop.vue'),
				meta: { title: 'live_classes', parent: 'live_class' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/Presential.vue'),
		children: [
			{
				path: 'presential-courses/:id/event/presential-class/:event_id/activities/:hierarchy_order',
				name: 'presential_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesMobile.vue')
						: import('pages/presential/ActivitiesDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential' },
			},
			{
				path: 'trails/:id_trail/presential-catalogs/:id_catalog/presential-courses/:id/event/presential-class/:event_id/activities/:hierarchy_order',
				name: 'trail_presential_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesMobile.vue')
						: import('pages/presential/ActivitiesDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/PresentialWebinar.vue'),
		children: [
			{
				path: 'presential-courses/:id/event/webinar/:event_id/activities/:hierarchy_order',
				name: 'presential_webinar_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesWebinarMobile.vue')
						: import('pages/presential/ActivitiesWebinarDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential_webinar' },
			},
			{
				path: 'trails/:id_trail/presential-catalogs/:id_catalog/presential-courses/:id/event/webinar/:event_id/activities/:hierarchy_order',
				name: 'trail_presential_webinar_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesWebinarMobile.vue')
						: import('pages/presential/ActivitiesWebinarDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential_webinar' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/PresentialLiveClass.vue'),
		children: [
			{
				path: 'presential-courses/:id/event/live-class/:event_id/activities/:hierarchy_order',
				name: 'presential_live_class_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesLiveClassMobile.vue')
						: import('pages/presential/ActivitiesLiveClassDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential_live_class' },
			},
			{
				path: 'trails/:id_trail/presential-catalogs/:id_catalog/presential-courses/:id/event/live-class/:event_id/activities/:hierarchy_order',
				name: 'trail_presential_live_class_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesLiveClassMobile.vue')
						: import('pages/presential/ActivitiesLiveClassDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential_live_class' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/PresentialReactions.vue'),
		children: [
			{
				path: 'presential-courses/:id/reactions/:hierarchy_order',
				name: 'presential_reactions_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesReactionsMobile.vue')
						: import('pages/presential/ActivitiesReactionsDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential_reactions' },
			},
			{
				path: 'trails/:id_trail/presential-catalogs/:id_catalog/presential-courses/:id/reactions/:hierarchy_order',
				name: 'trail_presential_reactions_activity',
				component: () =>
					Platform.is.mobile
						? import('pages/presential/ActivitiesReactionsMobile.vue')
						: import('pages/presential/ActivitiesReactionsDesktop.vue'),
				meta: { title: 'presentials', parent: 'presential_reactions' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/Lounge.vue'),
		children: [
			{
				path: 'webinars-lounge/:id',
				name: 'webinar_lounge',
				component: () => import('pages/Lounge.vue'),
				meta: { title: 'webinars', parent: 'closed' },
			},
			{
				path: 'trails/:id_trail/webinars-lounge/:id',
				name: 'trail_webinar_lounge',
				component: () => import('pages/Lounge.vue'),
				meta: { title: 'webinars', parent: 'closed' },
			},
		],
		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			next()
		},
	},
	{
		path: '/',
		component: () => import('layouts/Blank.vue'),
		children: [
			{
				path: '/onboarding',
				name: 'onboarding',
				component: () => import('pages/onboarding/Onboarding.vue'),
				meta: { title: 'Onboarding' },
			},
			{
				path: '/complete-register',
				name: 'complete_register',
				component: () => import('pages/complete_register/CompleteRegister.vue'),
				meta: { title: 'Complete Register' },
			},
		],
		beforeEnter: async (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			const { value: access_token_ios } = await Storage.get({ key: 'access_token' });
			if (!store.getters['common/access_token'] && !access_token_ios) {
				clearUserData(store)
				if (to.query.hasOwnProperty('token')) {
					store.dispatch('redirect/SET_TOKEN', [to.query.token])
				}
				store.dispatch('redirect/SET_REDIRECT', [to.path])
				next({ name: 'login' })
			} else {
				if (to.query.hasOwnProperty('token')) {
					clearUserData(store)
					store.dispatch('redirect/SET_TOKEN', [to.query.token])

					store.dispatch('redirect/SET_REDIRECT', [to.path])
					next({ name: 'login' })
				} else if (store.getters['redirect/redirect'] !== '') {
					let redirect = store.getters['redirect/redirect']
					store.dispatch('redirect/SET_REDIRECT', [''])
					next({ path: redirect })
				} else {
					next()
				}
			}
		},
	},
	// Always leave this as last one,
	// but you can also remove it
	{
		path: '/:catchAll(.*)*',
		component: () => import('pages/Error404.vue'),
	},
]

export default (store) => routes(store)

function clearUserData(store) {
	store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
	store.dispatch('common/SET_USER_DATA', [
		'',
		'',
		'',
		false,
		'',
		'',
		'',
		'',
		'',
		'',
		false,
		[],
		[],
		'',
		[],
		'',
		[],
		null,
		'',
		[],
		'',
		'',
		'',
		'',
		'',
		false,
		'',
	])
}
